import { makeStyles } from '@material-ui/core/styles'
import { PREV } from './mobile-carousel'

export const useMobileCarouselStyles = makeStyles({
  swipeable: {
    height: '100%'
  },
  wrapper: {
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  carouselContainer: {
    display: 'flex',
    paddingTop: 40,
    transition: props => (props.sliding ? 'none' : 'transform 0.5s ease'),
    transform: props => {
      if (!props.sliding) return 'translateX(calc(50% - 150px))'
      if (props.direction === PREV) return 'translateX(calc(20% - 150px))'
      return 'translateX(calc(50% + 150px))'
    }
  }
})
